import React from "react";
import IconComponent from "../Icons/IconComponent";
import { toast } from "react-toastify";

const TextField = ({ disabled, maxWidth, widthTextfield, placeholder, value, onChange, allowCopy, datePickerIcon, fixedValue, onClick, textAlign, maxlength }) => {

    const val = value ?? ""; // Avoid null

    return <div style={{ position: "relative", display: "flex", flexGrow: "1", cursor: onClick && !disabled ? "pointer" : "auto" }}
        onClick={onClick}>
        <input
            className="TextField-small-filled"
            type="text"
            disabled={disabled}
            readOnly={!onChange}
            style={{ flexGrow: "1", flex: "1", flexShrink: "0", fontSize: "14px", backgroundColor: "var(--input-background)",
                opacity: disabled ? "0.5" : "1",
                pointerEvents: fixedValue ? "none" : "auto",
                paddingRight: allowCopy || datePickerIcon ? "30px" : null,
                textAlign: textAlign ? textAlign : "left",
                width: widthTextfield ? widthTextfield : null,
                maxWidth: maxWidth ? maxWidth + "px" : null }}
            placeholder={placeholder}
            value={value !== null && value !== undefined ? value : ""}
            maxLength={maxlength ?? undefined}
            onChange={onChange || (() => {})}
        />
        {allowCopy ?
            <button type='button' className="button-round-secondary-icon-without-text"
                style={{ border: "transparent", position: "absolute", top: "10px", right: "0px" }}
                onClick={(event) => {
                    event.stopPropagation();
                    navigator.clipboard.writeText(value);
                    toast.success("Copied to clipboard");
                }}>
                <IconComponent nameIcon="clipboardcopy" color="carbone"/>
            </button> : null}
        {
            datePickerIcon ?
                <div style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)" }}>
                    <IconComponent nameIcon="calendar" color={disabled ? "grey-light" : "carbone"}/>
                </div>
                :
                null
        }
    </div>;
};
export default TextField;
